import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CreateDirectUploadMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateDirectUploadInput;
}>;

export type CreateDirectUploadMutationResult = { __typename?: 'Mutation' } & {
  createDirectUpload?: GraphQLTypes.Maybe<
    { __typename?: 'CreateDirectUploadPayload' } & {
      directUpload: { __typename?: 'DirectUpload' } & Pick<GraphQLTypes.DirectUpload, 'headers' | 'signedBlobId' | 'url'>;
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>>;
    }
  >;
};

export const CreateDirectUploadDocument = gql`
  mutation createDirectUpload($input: CreateDirectUploadInput!) {
    createDirectUpload(input: $input) {
      directUpload {
        headers
        signedBlobId
        url
      }
      errors {
        message
      }
    }
  }
`;
